import { Badge, Box } from "@mui/material"
import { useStyles } from "./styles"
import { ReactComponent as ChatBubbleIcon } from '../../../../../../../../assets/svg/chat-bubble.svg'

const CommentCountComponent = (props: any) => {
    const styles = useStyles()
    let totalComment = props?.current ?? 0


    return (
        <Box sx={styles.container}>
            <Badge
                badgeContent={totalComment}
                color="primary"
                showZero
                sx={[styles.iconFilter]}
            >
                <ChatBubbleIcon />
            </Badge>
        </Box>
    )
}

export { CommentCountComponent }